import { getIdTokenLocalStorage } from '@sbgsports/vault-sso-auth';
import { getAssetFromApi } from './assetsLookupsMetatags';
import { VAULT_MEDIA_TYPE } from '../../../constants/vault';
import { formUtcStringFromDate } from '../../../utils/time';

import { vaultApi } from './http';

export async function editAssetMetadata(assetDetails) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const { _id } = assetDetails;

  // Make copy of parameter
  const newAssetDetails = {
    ...assetDetails,
  };

  // Get latest details from asset
  const responseAsset = await getAssetFromApi(_id);

  if (responseAsset.type === VAULT_MEDIA_TYPE.liveVideo && newAssetDetails.start) {
    const dateValue = new Date(newAssetDetails.start);
    newAssetDetails.gameDate = formUtcStringFromDate(dateValue);
  }

  // VA-2468 Update oldVaultID and sha1 with latest values.
  if (responseAsset) {
    newAssetDetails.oldVaultID = responseAsset.oldVaultID;
    newAssetDetails.sha1 = responseAsset.sha1;
    // don't try to override status, even with the above get, it could be stale
    newAssetDetails.streamStatus = undefined;
  }

  const response = await vaultApi.put(`/assets/${_id}`, newAssetDetails);
  return response;
}

export async function bulkEditAssetsMetadata(assetDetailsArray) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.post('/assets/bulkupdate', assetDetailsArray);
  return response;
}
